import Vue from "vue"
import VueRouter from 'vue-router' 
Vue.use(VueRouter)

//解决连续多次点击跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
	  // mode: 'history',
    routes:[
        {
          path: '/',
          name: 'home',
          component: ()=>import('../views/home'),
        },
        {
          path: '/home',
          name: 'home',
          component: ()=>import('../views/home'),
        },
        {
          path: '/zcDtl',
          name: 'zcDtl',
          component: ()=>import('../views/zcDtl'),
        },

    ]
})


